import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import CheckBox from 'commons/src/components/input/Checkbox';
import MaterialIcon from 'commons/src/components/MaterialIcon';
import { getOrganizationLogo } from '../../../actions/organizationPropertiesActions';
import { paths } from '../../../constants';
import { Store } from '../../../reducers';
import { BusinessRequestType } from '../../../reducers/BusinessRequestType';

type ParentProps = {
    includeLogo: boolean;
    updateIncludeLogo: (included: boolean) => void;
};

export const LogoSectionComponent = ({ includeLogo, updateIncludeLogo }: ParentProps): React.ReactElement => {
    const { t: txt } = useTranslation();
    const dispatch = useDispatch();
    const logo = useSelector((state: Store) => state.organizationProperties.logoImage);
    const loading = useSelector(
        (state: Store) => state.requests[BusinessRequestType.GetOrganizationLogo]?.loading || false
    );
    const [logoError, setLogoError] = useState(false);
    useEffect(() => {
        dispatch(getOrganizationLogo());
    }, [dispatch]);

    const onChange = (): void => {
        if (logo) {
            updateIncludeLogo(!includeLogo);
        } else if (!loading) {
            setLogoError(true);
        }
    };

    return (
        <div>
            <div className="insight-tile__header insight-tile__header--padded insight-tile__header--no-border">
                <h2>{txt('Insight.Logo')}</h2>
            </div>
            <div className="form__row form__row--padded-small">
                <CheckBox
                    id="logo"
                    label={<span>{txt('Insight.CompanyLogoInPDF')}</span>}
                    labelIsElement
                    checked={includeLogo}
                    onChange={onChange}
                    disabled={loading}
                />
            </div>
            {logoError && (
                <div className="error-message error-message--with-icon">
                    <MaterialIcon name="error_outline" />
                    <Trans i18nKey="Insight.UploadLogoInOrgSettingsToInclude">
                        <Link to={`/${paths.organization}`} />
                    </Trans>
                </div>
            )}
        </div>
    );
};

export default LogoSectionComponent;
